import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Link, Typography, Stack } from '@mui/material';
// routes
import { PATH_AUTH } from '../../routes/paths';
// layouts
import AuthLayout from '../../layouts/AuthLayout';
// components
import Page from '../../components/Page';
import useAuth from '../../hooks/useAuth';
// sections
// sections
import { LoginForm } from '../../sections/auth/login';
import { APP_NAME } from '../../config';

// ----------------------------------------------------------------------

export default function Login() {
  const { setting } = useAuth();
  const appName = setting?.general?.app_name || APP_NAME;

  return (
    <Page title="Login">
      <AuthLayout title="Hi, Welcome Back">
        <Stack spacing={2} sx={{ mb: 5, position: 'relative' }}>
          <Typography variant="h4">Sign in to {appName}</Typography>

          <Typography sx={{ color: 'text.secondary' }}>Enter your details below.</Typography>
        </Stack>

        <LoginForm />

        <Typography variant="body2" align="center" sx={{ mt: 3 }}>
          Don’t have an account?{' '}
          <Link variant="subtitle2" component={RouterLink} to={PATH_AUTH.register}>
            Get started
          </Link>
        </Typography>
      </AuthLayout>
    </Page>
  );
}
